import React, { useState, useEffect, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuthFetch } from '../hooks/useAuthFetch';
import '../stili/SchedaFormComune.css';

const API_URL = process.env.REACT_APP_API_URL;

export default function Media() {
  const [formData, setFormData] = useState({
    titolo: '',
    descrizione: '',
    tipo: 'immagine',
    orientamento: 'orizzontale'
  });
  const [file, setFile] = useState(null);
  const [preview, setPreview] = useState(null);
  const [success, setSuccess] = useState('');
  const [error, setError] = useState('');
  const [mediaFiles, setMediaFiles] = useState([]);
  
  const authFetch = useAuthFetch();
  const navigate = useNavigate();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleFileChange = (e) => {
    const selectedFile = e.target.files[0];
    setFile(selectedFile);
    setPreview(URL.createObjectURL(selectedFile));
  };

  // Carica tutti i media dal DB
  const caricaMedia = useCallback(async () => {
    setError('');
    try {
      const response = await authFetch(`${API_URL}/api/admin/media`);
      if (!response.ok) throw new Error('Errore nel recupero media');
      const data = await response.json();
      setMediaFiles(data);
    } catch (err) {
      setError(err.message);
    }
  }, [authFetch]);

  useEffect(() => {
    caricaMedia();
  }, [caricaMedia]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess('');

    try {
      let fileUrl = '';

      if (file) {
        const form = new FormData();
        form.append('file', file);

        const uploadResponse = await authFetch(`${API_URL}/api/admin/media/upload`, {
          method: 'POST',
          body: form
        });

        if (!uploadResponse.ok) throw new Error('Errore durante l\'upload');
        fileUrl = await uploadResponse.text();
      }

      const response = await authFetch(`${API_URL}/api/admin/media`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ ...formData, url: fileUrl })
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || 'Errore durante l\'inserimento');
      }

      setSuccess('✅ Media inserito con successo!');
      setFormData({ titolo: '', descrizione: '', tipo: 'immagine', orientamento: 'orizzontale' });
      setFile(null);
      setPreview(null);
      caricaMedia();

    } catch (err) {
      setError(err.message);
    }
  };

  // Elimina media (record + file)
  const handleDelete = async (id) => {
    try {
      const response = await authFetch(`${API_URL}/api/admin/media/${id}`, { method: 'DELETE' });
      if (!response.ok) throw new Error('Errore durante l\'eliminazione');
      setSuccess('✅ Media eliminato con successo!');
      caricaMedia();
    } catch (err) {
      setError(err.message);
    }
  };

  return (
    <div className="form-container">
      <h2>Gestione Media</h2>
      {error && <div className="error-message">{error}</div>}
      {success && <div className="success-message">{success}</div>}

      <form onSubmit={handleSubmit}>
        <label>Titolo</label>
        <input type="text" name="titolo" value={formData.titolo} onChange={handleChange} required />

        <label>Descrizione</label>
        <textarea name="descrizione" rows="3" value={formData.descrizione} onChange={handleChange} required />

        <label>File Immagine</label>
        <input type="file" accept="image/*" onChange={handleFileChange} />
        {preview && <img src={preview} alt="Anteprima" style={{ width: '200px', marginTop: '10px' }} />}

        <label>Tipo</label>
        <select name="tipo" value={formData.tipo} onChange={handleChange}>
          <option value="immagine">Immagine</option>
          <option value="video">Video</option>
        </select>

        <label>Orientamento</label>
        <select name="orientamento" value={formData.orientamento} onChange={handleChange}>
          <option value="orizzontale">Orizzontale</option>
          <option value="verticale">Verticale</option>
        </select>

        <div className="button-row">
          <button className="custom-button" type="submit">Crea Media</button>
          <button className="custom-button" type="button" onClick={() => navigate('/gestionale')}>Torna al Gestionale</button>
        </div>
      </form>

      <h3>File disponibili</h3>
      <div className="media-list">
        {mediaFiles.map((media) => (
          <div key={media.id} className="media-item">
            <img src={media.url} alt={media.titolo} style={{ width: '150px', margin: '5px' }} />
            <button className="custom-button" onClick={() => handleDelete(media.id)}>Elimina</button>
          </div>
        ))}
      </div>
    </div>
  );
}
